import React, { useState } from 'react';
import { IAppProps } from '@interfaces/App.interface';
import { Grid, Typography } from '@ts/storybook';

/* import KPICard from '@components/Dashboard/KPICard';
import MainCard from '@components/Dashboard/MainCard';
import BarChart from '@components/Dashboard/BarChart';
import AreaChart from '@components/Dashboard/AreaChart';
import PieChart from '@components/Dashboard/PieChart';
import EventsTable from '@components/Dashboard/EventsTable';
import TasksTable from '@components/Dashboard/TasksTable';
import StackedBarChart from '@components/Dashboard/StackedBarChart'; */
import KPI from '@components/KPI';

interface DashboardProps extends IAppProps {}

const DashboardMockPage = (props: DashboardProps) => {
  const [value, setValue] = useState('today');
  const [slot, setSlot] = useState('week');

  const firstColor = '#201b50';
  const lastColor = '#077bc0';

  //#region Handlers
  const onChangeSlot = (item: any, type: string) => {
    setSlot(type);
  };
  //#endregion

  return (
    <Grid id="dashboard-rti" size={12} container rowSpacing={2.5} columnSpacing={2.75} p={4}>
      {/* row 1 */}
      {/* <Grid size={{xs:12}} sx={{ mb: -2.25 }}>
        <Typography variant="h5">Dashboard</Typography>
      </Grid> */}
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Trucks on site" dataCard={{ value: 12, oldValue: 7 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Personnel on site" dataCard={{ value: 187, oldValue: 100 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Warnings open" dataCard={{ value: 21, oldValue: 32 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Notifications in 24h" dataCard={{ value: 5, oldValue: 10 }} />
      </Grid>

      {/* row 2 */}
      <Grid size={{ xs: 12, md: 7, lg: 8 }}>
        <KPI.AreaChart
          {...props}
          id={'1'}
          isMock
          loading={false}
          title={'Site Operation Activity'}
          slot={slot}
          dataChart={{
            labels: [],
            series: [{ name: 'string', data: [] }],
          }}
          onChangeSlot={v => onChangeSlot(null, v)}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 5, lg: 4 }}>
        <KPI.PieChart
          {...props}
          title={'Warnings by severity'}
          dataChart={{
            labels: [],
            series: [{ name: 'string', data: [] }],
          }}
          loading={false}
          isMock
        />
      </Grid>

      {/* row 3 */}
      <Grid container rowSpacing={2.5} columnSpacing={2.75} size={12}>
        <Grid size={{ xs: 12, md: 7, lg: 8 }}>
          <KPI.MainCard sx={{ pt: 2 }} content={false}>
            <Grid size={{ xs: 12 }} ml={2}>
              <Typography
                variant="h5"
                color="primary"
                className="font-medium"
                text="Closed Loop Logistics - RTI inventory per location"
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <KPI.StackedBarChart type={1} />
            </Grid>
          </KPI.MainCard>
        </Grid>
        <Grid size={{ xs: 12, md: 5, lg: 4 }}>
          <KPI.BarChart
            {...props}
            options={{ color: '#FF8000', title: 'Machinery and tools' }}
            dataChart={{
              labels: [],
              series: [{ name: 'string', data: [] }],
            }}
            loading={false}
            isMock
          />
        </Grid>
      </Grid>

      {/* row 4 */}
      <Grid container rowSpacing={2.5} columnSpacing={2.75} size={12}>
        <Grid size={{ xs: 12, md: 7, lg: 8 }}>
          <KPI.MainCard sx={{ pt: 2 }} content={false}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid ml={2}>
                <Typography variant="h5" color="primary" text="Tasks Execution" className="font-medium" />
              </Grid>
              <Grid />
            </Grid>
            <KPI.TasksTable />
          </KPI.MainCard>
        </Grid>
        <Grid size={{ xs: 12, md: 5, lg: 4 }}>
          <KPI.BarChart
            {...props}
            options={{ color: '#0a8103', title: 'Personnel on site' }}
            dataChart={{
              labels: [],
              series: [{ name: 'string', data: [] }],
            }}
            loading={false}
            type={2}
            isMock
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DashboardMockPage;
